import { motion } from "framer-motion";
import { Cpu, HeartHandshake, MapPin } from "lucide-react";

const EASE = [0.22, 1, 0.36, 1];

const VALUES = [
  {
    icon: Cpu,
    title: "Mestiere artigianale",
    text: "Ogni macchina che entra in laboratorio viene aperta, capita e curata. Anche quelle che altri darebbero per finite.",
  },
  {
    icon: HeartHandshake,
    title: "Rapporto diretto",
    text: "Parli sempre con chi mette le mani sul tuo dispositivo. Preventivi chiari, nessuna sorpresa in fattura.",
  },
  {
    icon: MapPin,
    title: "Radicato nel territorio",
    text: "Empoli, Montelupo Fiorentino, Vinci, Capraia e Limite e dintorni: assistenza vicina, anche a domicilio.",
  },
];

export const About = () => (
  <section id="chi-sono" data-testid="about-section" className="relative py-20 sm:py-28 lg:py-36 bg-cream">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-14">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: EASE }}
        className="lg:col-span-5"
      >
        <p className="font-mono text-xs uppercase tracking-[0.22em] text-copper mb-5 flex items-center gap-3">
          <span className="w-8 h-px bg-copper inline-block" /> Chi sono
        </p>
        <h2 className="font-display font-bold tracking-tight leading-[1.12] text-3xl sm:text-4xl lg:text-5xl text-ink">
          Vent'anni di viti, cavi e sistemi <span className="text-copper">rimessi in piedi.</span>
        </h2>
        <div className="mt-10 flex items-center gap-8 border-t border-line pt-8">
          <div>
            <span className="font-display font-extrabold text-5xl text-ink block">2006</span>
            <span className="font-mono text-[11px] uppercase tracking-[0.15em] text-ash">primo laboratorio</span>
          </div>
          <span className="w-px h-14 bg-line" aria-hidden="true" />
          <div>
            <span className="font-display font-extrabold text-5xl text-copper block">oggi</span>
            <span className="font-mono text-[11px] uppercase tracking-[0.15em] text-ash">stessa passione</span>
          </div>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay: 0.12, ease: EASE }}
        className="lg:col-span-7"
      >
        <p className="text-base sm:text-lg leading-relaxed text-smoke">
          Da circa vent'anni mi occupo di tutto ciò che riguarda il mondo dell'informatica:
          riparo e reinstallo personal computer, risolvo problemi di sistema e aggiorno software e hardware,
          ridando vita a macchine ferme da anni. Con lo stesso sguardo attento seguo le nuove tecnologie,
          quando usate con criterio possono fare la differenza.
        </p>
        <p className="mt-5 text-base sm:text-lg leading-relaxed text-smoke">
          Progetto reti e impianti di fonia e dati, sviluppo siti internet e offro consulenza e assistenza
          a chiunque ne abbia bisogno nella nostra zona: la soluzione migliore è quella cucita sulle tue esigenze reali.
        </p>

        <div className="mt-12 grid sm:grid-cols-3 gap-5">
          {VALUES.map((v, i) => (
            <motion.div
              key={v.title}
              data-testid={`about-value-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: 0.1 + i * 0.1, ease: EASE }}
              whileHover={{ y: -6 }}
              className="bg-paper border border-line rounded-2xl p-6 shadow-[0_10px_30px_rgba(18,24,32,0.04)]"
            >
              <span className="w-11 h-11 rounded-xl bg-copper/10 flex items-center justify-center mb-4">
                <v.icon size={19} className="text-copper" />
              </span>
              <h3 className="font-display font-semibold text-base text-ink mb-2">{v.title}</h3>
              <p className="text-sm leading-relaxed text-smoke">{v.text}</p>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </div>
  </section>
);
